var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"target":"_blank","href":_vm.asegurarURL(_vm.medio, _vm.valor) || 'javascript:void(0)'}},[_c('VContactoBoton',{attrs:{"medio":_vm.medio,"tamaño":_vm.tamaño}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }